import React, { useState, useEffect } from "react";
import "./TestimonialSlider.css";

import { ReactComponent as Quote } from "../../../../assets/icons/quote.svg";

export default function TestimonialSlider() {
  const [index, setIndex] = useState(0);

  const quotes = [
    "GUP, I’m still partially in shock right now, but just wanted to say " +
      "thanks so much for everything and teaching me how to fish and grind " +
      "each week. My Wife and I are expecting our first child next month, so " +
      "this couldn’t have come at a better time for our family. I am beyond grateful",

    "Thanks to Gup for his great projections & analysis. It was a pleasure to beat TAMBO for the $4444 ticket, I’m sure that won’t happen very often.",
    "$200 into $2300.. yup I’ll take it",
    "Had a few bugger sweats but thankful for a decent ROI! Thanks GUP",
    "Top 10 in SE for main & final round SD…. Great content this week GUP, much appreciated!",
    "Came up just short, but what a fun sweat. Thanks GUP!!!! You have been on absolute fire!",
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      let nextIndex = index + 1;

      if (nextIndex >= quotes.length) {
        nextIndex = 0;
      }

      setIndex(nextIndex);
    }, 10000);
    // clearing interval
    return () => clearInterval(timer);
  });

  return (
    <div className="testimonial-slider">
      <Quote className="testimonial-quotation-icon" fill="#1FA980" />
      <p className="testimonial-content">
        <span className="testimonial-quote">{quotes[index]}</span>
        <span className="testimonial-author"></span>
      </p>
    </div>
  );
}
